<template>
  <div class="h5-wrap main">
    <img :src="src" alt="">
    <div class="btn-wrap">
      <el-button class="button" type="primary" @click="backIndex()">返回首页</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'IntroduceDetail',
  data () {
    return {
      pageItem: 1,
      src: ''
    }
  },
  created () {
    this.pageItem = this.$router.history.current.query.page
    this.src = `https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/fakeTools/${this.pageItem}.jpg`
  },
  methods: {
    backIndex() {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped lang="scss">
.main {
  h3 {
    margin: .2rem 0;
    // font-family: "YouSheBiaoTiHei";
    font-weight: bold;
    font-size: .20rem;
    text-align: center;
    letter-spacing: 0;
  }
  img {
    width: 100%;
  }
  .btn-wrap {
    padding: 0 .15rem .2rem;
  }
  .button {
    width: 100%;
    height: .5rem;
  }
}
</style>